<div class="page-title">Lead Criteria</div>

<div class="filter-search-section">
  <div class="search-section-wrapper" id="tour-search-lead-criteria">
    <app-search-input
      [placeholder]="'Search Lead Criteria ...'"
      [(searchQuery)]="searchQuery"
      (searchQueryChange)="onSearchQueryChange($event)"
    ></app-search-input>
  </div>
  <div class="add-criteria">
    <a
      id="tour-add-lead-criteria"
      href="javascript:void(0)"
      class="add-criteria-btn"
      (click)="onAddCriteria()"
    >
      <app-svg-icon
        [iconName]="'add.svg'"
        [height]="'16px'"
        [width]="'16px'"
        [style.fill]="'#fff'"
      ></app-svg-icon>
      <span>Add</span>
    </a>
  </div>
</div>

<!-- Leads Criteria List -->
<div class="leads-criteria-container">
  @if (loading) {
    <div class="no-criteria">
      <div class="no-criteria-content">
        <p>Loading lead criteria...</p>
      </div>
    </div>
  } @else if (filteredLeadsCriteria.length > 0) {
    <div class="criteria-grid">
      @for (
        criteria of filteredLeadsCriteria;
        track criteria.id;
        let i = $index
      ) {
        <div
          class="criteria-card"
          [class.is-matching]="criteria.is_matching_in_progress"
          [id]="'tour-criteria-item-' + i"
          (click)="onViewDetails(criteria.id)"
          (keyup.enter)="onViewDetails(criteria.id)"
          (keyup.space)="onViewDetails(criteria.id)"
          tabindex="0"
          role="button"
          [attr.aria-label]="'View details for ' + criteria.name"
        >
          <div class="card-header">
            <h3 class="criteria-name">{{ criteria.name }}</h3>
            <div class="header-actions">
              @if (criteria.is_matching_in_progress) {
                <div
                  class="matching-badge"
                  title="Matching process is currently running in background"
                >
                  <span class="matching-spinner"></span>
                  <span class="matching-text">Matching in progress...</span>
                </div>
              }
              @if (criteria.deprecated) {
                <div class="status-badge deprecated">Deprecated</div>
              } @else {
                <div
                  class="status-badge"
                  [class.active]="criteria.is_active"
                  [class.inactive]="!criteria.is_active"
                >
                  {{ criteria.is_active ? "Active" : "Inactive" }}
                </div>
                <div
                  class="toggle-switch"
                  (click)="onToggleActiveStatus($event, criteria)"
                  (keyup.enter)="onToggleActiveStatus($event, criteria)"
                  (keyup.space)="onToggleActiveStatus($event, criteria)"
                  tabindex="0"
                  role="switch"
                  [attr.aria-checked]="criteria.is_active"
                  [attr.aria-label]="'Toggle ' + criteria.name + ' status'"
                  [id]="'tour-criteria-toggle-' + i"
                >
                  <input
                    type="checkbox"
                    [checked]="criteria.is_active"
                    readonly
                    tabindex="-1"
                  />
                  <span class="slider">
                    <span class="slider-button"></span>
                  </span>
                </div>
              }
            </div>
          </div>
          <div class="card-content">
            @if (criteria.description) {
              <p class="criteria-description">{{ criteria.description }}</p>
            } @else {
              <p class="criteria-description no-description">
                No description provided
              </p>
            }
          </div>

          <div class="card-footer">
            <div class="created-info">
              <span class="created-by"
                >Updated by: {{ getCreatedByName(criteria.updated_by) }}</span
              >
              <span class="created-date">{{
                criteria.updated_at_utc | date: "medium"
              }}</span>
            </div>
            <div class="action-buttons">
              <button
                [id]="'tour-criteria-delete-item-' + i"
                class="view-btn delete-btn"
                (click)="onDeleteCriteria($event, criteria)"
                (keyup.enter)="onDeleteCriteria($event, criteria)"
                (keyup.space)="onDeleteCriteria($event, criteria)"
                tabindex="0"
                [attr.aria-label]="'Delete ' + criteria.name"
                title="Delete criteria"
              >
                <app-svg-icon
                  [iconName]="'delete.svg'"
                  [height]="'16px'"
                  [width]="'16px'"
                  [style.fill]="'#dc2626'"
                ></app-svg-icon>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="no-criteria">
      <div class="no-criteria-content">
        <h3>No Lead Criteria Found</h3>
        <p>
          There are no lead criteria created yet. Create your first criteria to
          get started.
        </p>
        <button class="create-first-btn" (click)="onAddCriteria()">
          <app-svg-icon
            [iconName]="'add.svg'"
            [height]="'16px'"
            [width]="'16px'"
            [style.fill]="'#fff'"
          ></app-svg-icon>
          Create First Criteria
        </button>
      </div>
    </div>
  }
</div>

<!-- Delete Confirmation Popup -->
@if (showDeleteConfirmation && criteriaToDelete) {
  <app-popup
    [heading]="'Are you sure you want to delete?'"
    [confirmText]="'Delete'"
    [cancelText]="'Cancel'"
    (confirmClicked)="onConfirmDelete()"
    (cancelClicked)="onCancelDelete()"
  >
    <div class="lead-unassign-popup-content">
      {{ criteriaToDelete.name }}
    </div>
  </app-popup>
}
